export const setActivities = (state, payload) => state.activities = payload;
export const setDashboardNotifications = (state, payload) => state.dashboardNotifications = payload;
export const loadBellNotifications = (state, payload) => {
    state.bellNotifications.data = [...state.bellNotifications.data,...payload.data];
    state.bellNotifications.avatarList = [...state.bellNotifications.avatarList, ...payload.avatarList];
    state.bellNotifications.hasMore = payload.hasMore;
    state.bellNotifications.hasUnread = payload.hasUnread;
};
export const fetchBellNotifications = (state, payload) => {
    state.bellNotifications.data = [...payload.data, ...state.bellNotifications.data,];
    state.bellNotifications.hasUnread = payload.hasUnread;
    state.bellNotifications.avatarList = [...state.bellNotifications.avatarList, ...payload.avatarList];
};
export const readBellNotification = (state, payload) => {
    state.bellNotifications.hasUnread = payload.hasUnread;
};

export const clearBell = (state) => {
    state.bellNotifications = {
        data: [],
        avatarList: [],
        hasMore: false
    }
};
export const setUser = (state, payload) => state.user = payload;
export const setUsers = (state, payload) => state.users = payload;
